import DOMPurify from "dompurify"

const purifyConfig = {
    ALLOWED_TAGS: [
        "p", "br", "b", "strong", "i", "em", "u", "s", "strike", "sub", "sup",
        "h1", "h2", "h3", "h4", "h5", "h6", "blockquote",
        "ul", "ol", "li", "a", "span", "div", "img",
        "table", "thead", "tbody", "tr", "td", "th"
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "width", "height", "style", "class", "colspan", "rowspan"]
}

const dangerousStylePattern = /expression\s*\(|javascript\s*:|-moz-binding|behavior\s*:/i

DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
    if (data.attrName === "style" && dangerousStylePattern.test(data.attrValue)) {
        data.keepAttr = false
    }
})

export const sanitizeHtml = html => {
    if (typeof html !== "string") return html
    return DOMPurify.sanitize(html, purifyConfig)
}